import { call, put, takeEvery } from 'redux-saga/effects';
import * as types from './unassignedSiteListActionType';
import * as actions from './unassignedSiteListActions';
import * as services from './unassignedSiteListServices';
import SweetAlert from '../../../../components/sweetalert/SweetAlert';
import * as commonActions from '../../../common/services/commonActions';

// Fetch Unassigned Site List Saga
function* fetchUnassignedSiteListSaga() {
    try {
        const response = yield call(services.getAllUnassignedSiteList);

        if (response?.success) {
            yield put(actions.fetchUnassignedSiteListSuccess(response.values || []));
        } else {
            yield put(actions.fetchUnassignedSiteListFailure('No unassigned facilities found'));
        }
    } catch (error) {
        console.error('Unassigned Site List Fetch Error:', error);
        yield put(actions.fetchUnassignedSiteListFailure('Failed to fetch unassigned facility list'));
    }
}

// Fetch Practice Dropdown Saga
function* fetchPracticeDropdownSaga() {
    try {
        const response = yield call(services.getPracticeDropdownData);

        if (response?.success) {
            yield put(actions.fetchPracticeDropdownSuccess(response.values || []));
        } else {
            yield put(actions.fetchPracticeDropdownFailure('Failed to fetch practice dropdown'));
        }
    } catch (error) {
        console.error('Practice Dropdown Fetch Error:', error);
        yield put(actions.fetchPracticeDropdownFailure('Failed to fetch practice dropdown'));
    }
}

// Fetch Sub Practice Dropdown Saga
function* fetchSubPracticeDropdownSaga() {
    try {
        const response = yield call(services.getSubPracticeDropdownData);

        if (response?.success) {
            yield put(actions.fetchSubPracticeDropdownSuccess(response || {}));
        } else {
            yield put(actions.fetchSubPracticeDropdownFailure('Failed to fetch sub-practice dropdown'));
        }
    } catch (error) {
        console.error('Sub Practice Dropdown Fetch Error:', error);
        yield put(actions.fetchSubPracticeDropdownFailure('Failed to fetch sub-practice dropdown'));
    }
}

// Save Bulk Practice Site Saga
function* saveBulkPracticeSiteSaga(action) {
    try {
        const response = yield call(services.saveBulkPracticeSiteData, action.payload);

        if (response?.success) {
            yield put(actions.saveBulkPracticeSiteSuccess(response));
            yield put(commonActions.assignedSitesCountRequest());
            yield put(commonActions.unassignedSitesCountRequest());

            // Show success message
            SweetAlert.success({
                title: 'Success!',
                text: 'Bulk practice facility mapping saved successfully.',
                timer: 2000,
                showConfirmButton: true
            });
        } else {
            yield put(actions.saveBulkPracticeSiteFailure(response?.errorMessage || 'Failed to save bulk practice facility mapping'));
            // Show error message
            SweetAlert.error({
                title: 'Error!',
                text: response?.errorMessage || 'Failed to save bulk practice facility mapping.',
                showConfirmButton: true
            });
        }
    } catch (error) {
        // Show error message
        SweetAlert.error({
            title: 'Error!',
            text: error?.message || 'Failed to save bulk practice facility mapping.',
            showConfirmButton: true
        });
        yield put(actions.saveBulkPracticeSiteFailure('Failed to save bulk practice facility mapping'));
    }
}

// Fetch Region/National by Practice Saga
function* fetchPracticeRegionNationalSaga(action) {
    try {
        const { siteId, practiceId } = action.payload || {};
        const response = yield call(services.getRegionAndNationalByPracticeId, practiceId);

        if (response?.success) {
            const details = response?.values || response?.value || null;
            yield put(actions.fetchPracticeRegionNationalSuccess({ siteId, details }));
        } else {
            yield put(actions.fetchPracticeRegionNationalFailure(response?.errorMessage || 'Failed to fetch region and national details'));
        }
    } catch (error) {
        console.error('Region/National Fetch Error:', error);
        yield put(actions.fetchPracticeRegionNationalFailure('Failed to fetch region and national details'));
    }
}

export default function* watchunassignedSiteListSaga() {
    yield takeEvery(types.FETCH_UNASSIGNED_SITE_LIST_REQUEST, fetchUnassignedSiteListSaga);
    yield takeEvery(types.FETCH_UNASSIGNED_PRACTICE_DROPDOWN_REQUEST, fetchPracticeDropdownSaga);
    yield takeEvery(types.FETCH_UNASSIGNED_SUB_PRACTICE_DROPDOWN_REQUEST, fetchSubPracticeDropdownSaga);
    yield takeEvery(types.SAVE_UNASSIGNED_BULK_PRACTICE_SITE_REQUEST, saveBulkPracticeSiteSaga);
    yield takeEvery(types.FETCH_UNASSIGNED_REGION_NATIONAL_BY_PRACTICE_REQUEST, fetchPracticeRegionNationalSaga);
}